import { PropertySetModule } from "@/services/admin/property-set/modal"
import { ChemicalComponent } from "@/services/chemical-component"
import { useMemo } from "react"
import KaTeX from 'katex'
import { QuestionCircleOutlined } from "@ant-design/icons"
import { Space, Tooltip } from "antd"
import { isEquationValid } from "./utils"
import "katex/dist/katex.min.css";
import "katex/contrib/mhchem/mhchem";

interface EquationProps {
  value: PropertySetModule.ReactionPartner[]
  components: ChemicalComponent.Modal[]
}

export function Equation(props: EquationProps) {
  const {value, components} = props
  const options = useMemo(() => {
    return value.map(item => {
      return {
        num: item.stoec,
        formula: components.find(component => item.id === component.id)?.formula || '-'
      }
    })
  }, [value, components])
  if (options.length === 0) {
    return null
  }

  const isValid = isEquationValid(options)

  const left = options.filter(item => item.num < 0).map(item => {
    if (item.num === -1) {
      return item.formula
    }
    return `${Math.abs(item.num)} ${item.formula}`
  }).join(' + ')
  const right = options.filter(item => item.num > 0).map(item => {
    if (item.num === 1) {
      return item.formula
    }
    return `${item.num} ${item.formula}`
  }).join(' + ')

  const html = KaTeX.renderToString(`\\ce{${left}->${right}}`, { throwOnError: false})

  return <Space>
    <div dangerouslySetInnerHTML={{__html: html}}></div>
    {!isValid && <Tooltip title="stoichiometric coefficient times molecular weight">
      <QuestionCircleOutlined style={{color: '#FF3D00'}} />
    </Tooltip>}
  </Space>
}